
// Define Application Types as an enum
export enum ApplicationTypeEnum {
  IdCase = "id-case",
  CredentialVerificationCase = "credential-verification-case",
  SendReportCase = "send-report-case",
}